




































































































































































































































































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import McuImsSvc from "@/services/McuIms";
import { storeMcuIms } from "@/store/modules/McuIms";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import * as Calc from "@/utils/mcuImsCalculator";
import type { McuImsInterface } from "@/types/mcu_ims";

@Component({ components: { CardModalTtd } })
export default class McuImsTabPage extends Vue {
  @Prop({ required: true }) register!: any;
  @Prop({ required: true }) rm!: string;
  @Prop({ default: () => ({}) }) pasien!: any;

  openPanels: number[] = [0, 4, 6];
  saving = false;
  modalTtd = false;
  currentEditing = false;

  form: McuImsInterface & Record<string, any> = this.defaultForm();
  anamnesis: any = { rpd: [], operasi: [], alergi: [], pengobatan: [], penyakit_keluarga: [], imunisasi: [] };
  hra: any = {
    merokok: { status: "", batang_hari: null, lama_tahun: null, pack_year: null },
    alkohol: { audit_c_items: [null, null, null], audit_c_skor: null, audit_c_interpretasi: null },
    phq9: { items: Array(9).fill(null), skor: null, interpretasi: null, suicide_red_flag: false },
    gad7: { items: Array(7).fill(null), skor: null, interpretasi: null }
  };
  pekerjaan: any = { jenis_pajanan: [], apd: [], kecelakaan_kerja: [], pak: [] };
  vs: any = {};
  lab: any = {
    hematologi_rutin: {},
    kimia_darah: {},
    urinalisis: {},
    serologi: {},
    toksikologi: {}
  };
  toksikologiNapza = "";
  thoraxKesan = "";
  thoraxIlo = "";
  usgAbdomenKesan = "";
  ekg: any = {};
  audiometri: any = { AD: {}, AS: {} };
  spirometri: any = {};
  konseling: any = { topik: [] };

  dokterOptions: any[] = [];

  // Sinkronisasi multi-pemeriksa
  assignSearchItems: any[] = [];
  assignSearchLoading = false;
  penunjangList: any[] = [];
  newSectionKey: string | null = null;
  sectionCatalog: Record<string, any> = {};
  private assignSearchTimer: any = null;
  // Isi hasil pemeriksa per-section
  fillDialog = false;
  activeSection: any = null;
  sectionFill: any = { hasil: "", kesan: "", rekomendasi: "" };
  sectionSaving = false;
  ttdContext: "dpjp" | "section" = "dpjp";

  audiometriFreqs = [250, 500, 1000, 2000, 3000, 4000, 6000, 8000];

  phq9Labels = [
    "Kurang minat / kesenangan dalam melakukan sesuatu",
    "Merasa murung, sedih, atau putus asa",
    "Sulit tidur / tidur terlalu banyak",
    "Merasa lelah / kurang berenergi",
    "Nafsu makan kurang / berlebihan",
    "Merasa diri sendiri buruk / mengecewakan keluarga",
    "Sulit konsentrasi (mis. membaca koran/TV)",
    "Gerakan/bicara lambat — atau sebaliknya gelisah",
    "Pikiran lebih baik mati / menyakiti diri sendiri"
  ];
  gad7Labels = [
    "Gugup, cemas, atau gelisah",
    "Tidak bisa menghentikan / mengontrol kekhawatiran",
    "Terlalu mengkhawatirkan berbagai hal",
    "Sulit untuk santai",
    "Sangat gelisah sehingga sulit duduk diam",
    "Mudah jengkel / kesal",
    "Takut sesuatu yang buruk akan terjadi"
  ];
  auditCLabels = [
    "Seberapa sering Anda minum minuman beralkohol?",
    "Berapa banyak gelas (standar) saat minum?",
    "Seberapa sering Anda minum ≥6 gelas dalam 1 kesempatan?"
  ];
  likert4 = [
    { value: 0, label: "0 — Tidak pernah" },
    { value: 1, label: "1 — Beberapa hari" },
    { value: 2, label: "2 — Lebih dari separuh hari" },
    { value: 3, label: "3 — Hampir setiap hari" }
  ];
  likert5 = [
    { value: 0, label: "0" },
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" }
  ];
  merokokOptions = ["tidak_pernah", "mantan", "aktif"];

  /* ===== getters ===== */
  get items() { return storeMcuIms.items; }
  get masters() { return storeMcuIms.masters; }
  get paketOptions() { return this.masters.paket; }
  get shiftOptions() { return this.masters.pekerjaan_shift; }
  get fitnessOptions() { return this.masters.fitness; }
  get rekomendasiTlOptions() { return this.masters.rekomendasi_tl; }
  get pajananOptions() { return this.masters.pajanan; }

  get currentPaket() {
    return this.paketOptions.find(p => p.kode === this.form.paket_kode);
  }
  get needsOkupasi() {
    return this.currentPaket?.requires_okupasi || false;
  }
  get isCpmi() {
    return this.form.paket_kode === "mcu_cpmi";
  }
  get needsEkg() {
    return ["mcu_standard", "mcu_executive", "mcu_pre_employment", "mcu_periodical", "mcu_cpmi", "mcu_pra_purnabakti", "mcu_return_to_work"].includes(this.form.paket_kode || "");
  }
  get autoReasonIcd10() {
    return this.currentPaket?.reason_icd10_default || "Z00.0";
  }

  get imt() { return Calc.hitungImt(this.form.tb_cm, this.form.bb_kg); }
  get imtKategori() { return Calc.klasifikasiImt(this.imt); }
  get imtKategoriLabel() { return Calc.labelKlasifikasiImt(this.imtKategori); }
  get imtChipColor() {
    if (!this.imtKategori) return "grey";
    if (this.imtKategori === "obesitas_2") return "red";
    if (this.imtKategori === "obesitas_1") return "orange";
    if (this.imtKategori === "overweight") return "amber darken-2";
    if (this.imtKategori === "underweight") return "blue";
    return "green";
  }
  get tdKlas() { return Calc.klasifikasiTd(this.vs.td_sistolik, this.vs.td_diastolik); }
  get tdKlasLabel() { return Calc.labelKlasifikasiTd(this.tdKlas); }
  get tdChipColor() {
    if (!this.tdKlas) return "grey";
    if (this.tdKlas === "ht_2") return "red";
    if (this.tdKlas === "ht_1" || this.tdKlas === "ht_isolated_sistolik") return "deep-orange";
    if (this.tdKlas === "pre_ht") return "amber darken-2";
    return "green";
  }

  get packYear() { return Calc.hitungPackYear(this.hra.merokok.batang_hari, this.hra.merokok.lama_tahun); }

  get phq9Skor() { return Calc.skorPhq9(this.hra.phq9.items); }
  get phq9Interpretasi() {
    const k = Calc.interpretasiPhq9(this.phq9Skor);
    return k ? k.replace(/_/g, " ") : "-";
  }
  get phq9SuicideFlag() { return Calc.isPhq9SuicideRedFlag(this.hra.phq9.items); }

  get gad7Skor() { return Calc.skorGad7(this.hra.gad7.items); }
  get gad7Interpretasi() {
    const k = Calc.interpretasiGad7(this.gad7Skor);
    return k || "-";
  }

  get auditCSkor() { return Calc.skorAuditC(this.hra.alkohol.audit_c_items); }
  get auditCInterpretasi() {
    const gender = this.pasien?.sex || this.form.pasien?.sex || "L";
    return Calc.interpretasiAuditC(this.auditCSkor, gender) || "-";
  }

  get ptaAd() { return Calc.hitungPtaAudiometri(this.audiometri.AD); }
  get ptaAs() { return Calc.hitungPtaAudiometri(this.audiometri.AS); }
  get ptaAdKategori() { const k = Calc.klasifikasiPtaWho(this.ptaAd); return k ? k.replace(/_/g, " ") : "-"; }
  get ptaAsKategori() { const k = Calc.klasifikasiPtaWho(this.ptaAs); return k ? k.replace(/_/g, " ") : "-"; }

  get hivReaktif() {
    return String(this.lab.serologi.hiv || "").toLowerCase() === "reaktif";
  }
  get hbsagReaktif() {
    return String(this.lab.serologi.hbsag || "").toLowerCase() === "reaktif";
  }

  get warningBanners() {
    const out: { type: string; title: string; message: string }[] = [];
    if (this.phq9SuicideFlag) {
      out.push({ type: "error", title: "PHQ-9 Suicide Red Flag", message: "Item-9 ≥1. Jadwalkan konsul Sp.KJ <24 jam." });
    }
    if (this.vs.td_sistolik >= 180 || this.vs.td_diastolik >= 120) {
      out.push({ type: "error", title: "Hipertensi Krisis", message: "TD ≥180/120 mmHg. Pertimbangkan rujuk IGD." });
    }
    if (this.imtKategori === "obesitas_2") {
      out.push({ type: "warning", title: "Obesitas II", message: "IMT ≥30 — risiko kardiometabolik tinggi." });
    }
    if (this.hivReaktif) {
      out.push({ type: "warning", title: "Privasi", message: "Hasil HIV sensitif — Lakukan VCT post-test counseling." });
    }
    if (this.hbsagReaktif) {
      out.push({ type: "warning", title: "HBsAg Reaktif", message: "Rujuk Sp.PD GE-H untuk evaluasi lebih lanjut." });
    }
    return out;
  }

  /* ===== getters multi-pemeriksa ===== */
  get sortedSections(): any[] {
    const list = (this.form.sections as any[]) || [];
    return [...list].sort((a, b) => (a.urutan || 0) - (b.urutan || 0));
  }
  get sectionsTotal(): number {
    return this.sortedSections.length;
  }
  get sectionsDone(): number {
    return this.sortedSections.filter(s => s.is_complete).length;
  }
  get sectionsProgressColor(): string {
    if (!this.sectionsTotal) return "grey";
    if (this.sectionsDone >= this.sectionsTotal) return "green";
    if (this.sectionsDone > 0) return "amber darken-2";
    return "red";
  }
  get addableSectionOptions(): { key: string; label: string }[] {
    const existing = this.sortedSections.map(s => s.section_key);
    return Object.keys(this.sectionCatalog)
      .filter(k => !existing.includes(k))
      .map(k => ({ key: k, label: this.sectionCatalog[k].label }));
  }
  // Daftar opsi pemeriksa — computed (stabil/ter-cache) agar tidak memicu
  // infinite render loop pada v-autocomplete. Gabungan penunjang + hasil
  // pencarian dokter + pemeriksa yang sudah ditugaskan (agar nama tampil).
  get assignOptions(): { id: number; nama: string }[] {
    const opts: { id: number; nama: string }[] = [
      ...this.penunjangList,
      ...this.assignSearchItems
    ];
    this.sortedSections.forEach(s => {
      if (s.assigned_user && s.assigned_user.id) {
        opts.push({ id: s.assigned_user.id, nama: s.assigned_user.nama });
      }
    });
    const seen: Record<string, boolean> = {};
    return opts.filter(o => {
      if (!o || o.id == null || seen[o.id]) return false;
      seen[o.id] = true;
      return true;
    });
  }

  /* ===== lifecycle ===== */
  async created() {
    await storeMcuIms.loadMasters();
    await storeMcuIms.getByRegister(this.register);
    await this.fetchDokterOptions();
    if (this.items.length > 0) {
      // tampilkan record terakhir untuk edit
      await this.openExisting(this.items[0]);
    }
  }

  @Watch("form.paket_kode")
  onPaketChange() {
    if (this.currentPaket && !this.form.reason_icd10) {
      this.form.reason_icd10 = this.currentPaket.reason_icd10_default;
    }
  }

  /* ===== methods ===== */
  defaultForm(): any {
    return {
      paket_kode: "mcu_basic",
      tgl_mcu: localISODate(),
      jam_mulai: "08:00",
      jam_selesai: null,
      dokter_pj_id: null,
      diagnosis_primer_icd10: "Z00.0",
      reason_icd10: "Z00.0",
      tempat_tanda_tangan: "Bantul",
      is_locked: false,
      has_any_signature: false,
      signed_by_dpjp: false,
      signed_by_peserta: false
    };
  }

  async fetchDokterOptions() {
    // Pakai user yang login sebagai default
    const me: any = userModule.user;
    if (me?.id) {
      this.dokterOptions = [{ id: me.id, nama: me.nama || me.username }];
      if (!this.form.dokter_pj_id) this.form.dokter_pj_id = me.id;
    }
  }

  async openExisting(item: any) {
    if (!item?.id) return;
    try {
      const dt = await McuImsSvc.find(item.id);
      const d = dt.data.data;
      this.form = { ...this.defaultForm(), ...d };
      this.anamnesis = d.anamnesis || this.anamnesis;
      this.hra = d.hra || this.hra;
      if (!this.hra.phq9?.items) this.hra.phq9 = { items: Array(9).fill(null) };
      if (!this.hra.gad7?.items) this.hra.gad7 = { items: Array(7).fill(null) };
      if (!this.hra.alkohol?.audit_c_items) this.hra.alkohol = { audit_c_items: [null, null, null] };
      if (!this.hra.merokok) this.hra.merokok = { status: "", batang_hari: null, lama_tahun: null };
      this.pekerjaan = d.pekerjaan_pajanan || this.pekerjaan;
      this.vs = d.vital_sign || {};
      this.lab = { ...this.lab, ...(d.lab || {}) };
      this.thoraxKesan = d.radiologi?.thorax_pa?.kesan || "";
      this.thoraxIlo = d.radiologi?.thorax_pa?.ilo_kategori || "";
      this.usgAbdomenKesan = d.radiologi?.usg_abdomen?.kesan || "";
      this.ekg = d.ekg || {};
      this.audiometri = d.audiometri || { AD: {}, AS: {} };
      this.spirometri = d.spirometri || {};
      this.konseling = d.konseling || { topik: [] };
      this.toksikologiNapza = (d.lab?.toksikologi?.urine_drug_screen as string) || "";
      this.currentEditing = true;
      await this.refreshSections();
    } catch (e) {
      // ignore
    }
  }

  buildPayload(): any {
    const payload: any = {
      register_id: this.register,
      pasien_rm: this.rm,
      context: "ralan",
      paket_kode: this.form.paket_kode,
      tgl_mcu: this.form.tgl_mcu,
      jam_mulai: this.form.jam_mulai,
      jam_selesai: this.form.jam_selesai || null,
      dokter_pj_id: this.form.dokter_pj_id,
      reason_icd10: this.form.reason_icd10 || this.autoReasonIcd10,
      perusahaan_nama: this.form.perusahaan_nama || null,
      perusahaan_alamat: this.form.perusahaan_alamat || null,
      jabatan: this.form.jabatan || null,
      departemen: this.form.departemen || null,
      masa_kerja_tahun: this.form.masa_kerja_tahun || null,
      shift_kerja: this.form.shift_kerja || null,
      kbli_industri: this.form.kbli_industri || null,
      negara_tujuan: this.form.negara_tujuan || null,
      no_paspor: this.form.no_paspor || null,
      anamnesis: this.anamnesis,
      hra: this.hra,
      pekerjaan_pajanan: this.pekerjaan,
      vital_sign: this.vs,
      tb_cm: this.form.tb_cm || null,
      bb_kg: this.form.bb_kg || null,
      lingkar_perut_cm: this.form.lingkar_perut_cm || null,
      lingkar_pinggul_cm: this.form.lingkar_pinggul_cm || null,
      lab: { ...this.lab, toksikologi: this.toksikologiNapza ? { urine_drug_screen: this.toksikologiNapza } : null },
      radiologi: {
        thorax_pa: this.thoraxKesan ? { kesan: this.thoraxKesan, ilo_kategori: this.thoraxIlo } : null,
        usg_abdomen: this.usgAbdomenKesan ? { kesan: this.usgAbdomenKesan } : null
      },
      ekg: this.ekg,
      audiometri: this.audiometri,
      spirometri: this.spirometri,
      konsul_spesialis: this.form.konsul_spesialis || [],
      diagnosis_primer_icd10: this.form.diagnosis_primer_icd10,
      diagnosis_tambahan: this.form.diagnosis_tambahan || [],
      status_pak: this.form.status_pak || null,
      framingham_score: this.form.framingham_score || null,
      fitness_status: this.form.fitness_status || null,
      fitness_catatan: this.form.fitness_catatan || null,
      fitness_valid_until: this.form.fitness_valid_until || null,
      fitness_justifikasi: this.form.fitness_justifikasi || null,
      cpmi_hasil_final: this.form.cpmi_hasil_final || null,
      cpmi_alasan_unfit: this.form.cpmi_alasan_unfit || null,
      konseling: this.konseling,
      rekomendasi_tl: this.form.rekomendasi_tl || null,
      tgl_kontrol_berikutnya: this.form.tgl_kontrol_berikutnya || null,
      sertifikat_berlaku_sampai: this.form.sertifikat_berlaku_sampai || null,
      ringkasan_eksekutif: this.form.ringkasan_eksekutif || null,
      tempat_tanda_tangan: this.form.tempat_tanda_tangan || "Bantul"
    };
    return payload;
  }

  async save() {
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let dt: any;
      if (this.form.id) {
        dt = await McuImsSvc.update(this.form.id, payload);
      } else {
        dt = await McuImsSvc.create(payload);
      }
      const saved = dt.data.data;
      this.form = { ...this.form, ...saved };
      this.currentEditing = true;
      await this.refreshSections();
      await storeMcuIms.getByRegister(this.register);
      appModule.sendSuccessNotice("Berhasil menyimpan MCU.");
    } catch (e) {
      // ErrorAlert sudah ditangani service
    }
    this.saving = false;
  }

  openTtdModal() {
    if (!this.form.id) return;
    this.ttdContext = "dpjp";
    this.modalTtd = true;
  }

  async onTtdPassed(password: string) {
    if (this.ttdContext === "section") {
      await this.onSectionTtdPassed(password);
      return;
    }
    if (!this.form.id) return;
    try {
      await McuImsSvc.signDpjp(this.form.id, { password });
      this.afterSignSuccess();
    } catch (err) {
      // Gate: masih ada pemeriksa wajib belum selesai → tawarkan override dengan alasan.
      const e: any = err;
      if (e?.response?.status === 422) {
        const pending = e.response.data?.pending_sections || [];
        const names = pending.map((p: any) => p.section_label).join(", ");
        const reason = window.prompt(
          `Masih ada pemeriksaan wajib belum selesai:\n${names}\n\n` +
            `Isi alasan untuk tetap finalisasi (mis. "Sp.S berhalangan"), atau Batal.`,
          ""
        );
        if (reason && reason.trim()) {
          try {
            await McuImsSvc.signDpjp(this.form.id, {
              password,
              finalize_override_reason: reason.trim()
            });
            this.afterSignSuccess();
          } catch (e2) {
            // ditangani service
          }
        }
      }
    }
  }

  async afterSignSuccess() {
    appModule.sendSuccessNotice("Berhasil menandatangani MCU sebagai DPJP.");
    this.modalTtd = false;
    await storeMcuIms.getByRegister(this.register);
    const updated = this.items.find(i => i.id === this.form.id);
    if (updated) await this.openExisting(updated);
  }

  /* ===== methods multi-pemeriksa ===== */
  async refreshSections() {
    if (!this.form.id) return;
    try {
      const dt = await McuImsSvc.getSections(this.form.id);
      const d = dt.data?.data || {};
      this.sectionCatalog = d.catalog || {};
      this.$set(this.form, "sections", d.sections || []);
    } catch (e) {
      // ignore
    }
  }

  onAssignSearch(term: string) {
    if (!term || term.length < 2) return;
    if (this.assignSearchTimer) clearTimeout(this.assignSearchTimer);
    this.assignSearchTimer = setTimeout(async () => {
      this.assignSearchLoading = true;
      try {
        const dt = await McuImsSvc.searchDokter(term);
        const rows = dt.data?.data || [];
        this.assignSearchItems = (rows as any[]).map(u => ({
          id: u.user_id || u.id,
          nama: u.nama
        }));
      } catch (e) {
        this.assignSearchItems = [];
      }
      this.assignSearchLoading = false;
    }, 350);
  }

  async onAssign(sec: any, userId: number | null) {
    if (!sec.id) return;
    try {
      const dt = await McuImsSvc.assignSection(sec.id, userId || null);
      const updated = dt.data?.data;
      this.applySectionUpdate(updated);
    } catch (e) {
      // ditangani service
    }
  }

  async addSection() {
    if (!this.form.id || !this.newSectionKey) return;
    try {
      await McuImsSvc.addSection(this.form.id, { section_key: this.newSectionKey });
      this.newSectionKey = null;
      await this.refreshSections();
      appModule.sendSuccessNotice("Pemeriksaan ditambahkan.");
    } catch (e) {
      // ditangani service
    }
  }

  async removeSection(sec: any) {
    if (!sec.id) return;
    if (!confirm(`Hapus pemeriksaan "${sec.section_label}"?`)) return;
    try {
      await McuImsSvc.deleteSection(sec.id);
      await this.refreshSections();
      appModule.sendSuccessNotice("Pemeriksaan dihapus.");
    } catch (e) {
      // ditangani service
    }
  }

  applySectionUpdate(updated: any) {
    if (!updated) return;
    const list = (this.form.sections as any[]) || [];
    const idx = list.findIndex(s => s.id === updated.id);
    if (idx >= 0) {
      this.$set(list, idx, updated);
      this.$set(this.form, "sections", list);
    }
  }

  /* ===== isi hasil pemeriksa per-section ===== */
  openFillSection(sec: any) {
    this.activeSection = sec;
    const c = sec.content || {};
    this.sectionFill = {
      hasil: c.hasil || "",
      kesan: sec.kesan || "",
      rekomendasi: sec.rekomendasi || ""
    };
    this.fillDialog = true;
  }

  async saveSectionFill(submit: boolean) {
    if (!this.activeSection || !this.activeSection.id) return;
    this.sectionSaving = true;
    try {
      const dt = await McuImsSvc.updateSection(this.activeSection.id, {
        content: { hasil: this.sectionFill.hasil },
        kesan: this.sectionFill.kesan,
        rekomendasi: this.sectionFill.rekomendasi,
        submit
      });
      this.applySectionUpdate(dt.data && dt.data.data);
      appModule.sendSuccessNotice(submit ? "Pemeriksaan ditandai selesai." : "Draft tersimpan.");
      this.fillDialog = false;
    } catch (e) {
      // ditangani service
    }
    this.sectionSaving = false;
  }

  openSectionTtd() {
    this.ttdContext = "section";
    this.modalTtd = true;
  }

  async onSectionTtdPassed(password: string) {
    if (!this.activeSection || !this.activeSection.id) return;
    try {
      await McuImsSvc.updateSection(this.activeSection.id, {
        content: { hasil: this.sectionFill.hasil },
        kesan: this.sectionFill.kesan,
        rekomendasi: this.sectionFill.rekomendasi,
        submit: true
      });
      const dt = await McuImsSvc.signSection(this.activeSection.id, { password });
      this.applySectionUpdate(dt.data && dt.data.data);
      appModule.sendSuccessNotice("Berhasil menandatangani pemeriksaan.");
      this.modalTtd = false;
      this.fillDialog = false;
      await this.refreshSections();
    } catch (e) {
      // ditangani service
    } finally {
      this.ttdContext = "dpjp";
    }
  }

  statusColor(status: string): string {
    if (status === "signed") return "green";
    if (status === "submitted") return "teal";
    if (status === "in_progress") return "amber darken-2";
    return "grey";
  }
  statusLabel(status: string): string {
    const map: Record<string, string> = {
      pending: "Menunggu",
      in_progress: "Dikerjakan",
      submitted: "Selesai",
      signed: "Ditandatangani"
    };
    return map[status] || status;
  }

  printPdf() {
    if (!this.form.id) return;
    McuImsSvc.print(this.form.id);
  }

  get bisaHapus(): boolean {
    if (!this.form.id) return false;
    const me: any = userModule.user;
    return !alasanTtdMengunciHapus(
      this.form.creator_user_id,
      [
        { ditandatangani: this.form.signed_by_dpjp, penandaTanganId: this.form.dokter_pj_id },
        { ditandatangani: this.form.signed_by_peserta, penandaTanganId: null }
      ],
      me && me.id
    );
  }

  async remove() {
    if (!this.bisaHapus) return;
    if (!confirm("Hapus MCU ini? Tindakan tidak dapat dibatalkan.")) return;
    try {
      await McuImsSvc.destroy(this.form.id);
      appModule.sendSuccessNotice("Berhasil menghapus MCU.");
      this.form = this.defaultForm();
      this.currentEditing = false;
      await storeMcuIms.getByRegister(this.register);
    } catch (e) {
      // ignore
    }
  }
}
